import React from 'react';
import { useCheckout } from './CheckoutContext';
export function OfferBox() {
  const {
    openUpsell,
    warmConnection
  } = useCheckout();
  return <section className="px-4 py-7 sm:py-9 border-t border-brand-gold/10" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <div className="border border-brand-gold bg-dark-card rounded-lg p-5 sm:p-7 shadow-2xl" data-id="element-167">
          <h3 className="font-serif text-xl sm:text-2xl font-bold text-center mb-4" data-id="element-168">
            Acceso completo a Realmanifestación
          </h3>

          <div className="text-center mb-4" data-id="element-169">
            <p className="text-brand-gray line-through text-sm sm:text-base mb-0" data-id="element-170">
              Precio normal: $50.000 ARS
            </p>
            <p className="text-brand-gold text-3xl sm:text-4xl font-bold leading-tight" data-id="element-171">
              HOY $19.990 ARS
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-4 gap-y-1.5 max-w-md mx-auto mb-5" data-id="element-172">
            {['Descarga inmediata', 'Acceso permanente', 'Garantía 7 días', 'Actualizaciones futuras'].map((item, i) => <div key={i} className="flex items-center gap-2 text-xs sm:text-sm" data-id="element-173">
                <span className="text-brand-gold" data-id="element-174">✓</span>
                <span data-id="element-175">{item}</span>
              </div>)}
          </div>

          <button onClick={openUpsell} onMouseEnter={warmConnection} onTouchStart={warmConnection} className="w-full bg-brand-gold text-brand-black px-6 py-3.5 rounded text-base sm:text-lg font-bold hover:opacity-90 transition-all hover:scale-[1.02]" data-id="element-176">
            QUIERO ACCESO AHORA
          </button>
        </div>
      </div>
    </section>;
}